import {SimplePresentation, SimplePresentationRunnerController} from "../../SimplePresentationRunner";
import {gsap} from "gsap";
import {XwaysHoarder2} from "../../XwaysHoarder2";
import {WinConfig, WinConfigUtil} from "../../utils/WinConfigUtil";
import {BasicSymbol, SymbolStates} from "../../reels/symbols/BasicSymbol";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {XwaysHoarder2Sound} from "../../sound/XwaysHoarder2Sound";
import {Reel} from "../../reels/Reel";
import {SimpleReelModelSymbolData} from "../../../core/reel/simplereel/SimpleReelModel";


export class NormalWin implements SimplePresentation {

    name: string = "NormalWin";
    countupFinishTime: number;

    constructor() {
    }

    shouldRun(): boolean {
        return XwaysHoarder2.model.winRatio > 0 && !XwaysHoarder2.model.isBigWin && !XwaysHoarder2.model.data.brokeTheBank;
    }

    start(controller: SimplePresentationRunnerController): void {
        const tl: gsap.core.Timeline = gsap.timeline({
            onStart:()=>{
                controller.setSkipCallback();
            }
        });
        XwaysHoarder2.winView.skipped = false;
        const isBigWin = XwaysHoarder2.model.winRatio >= 15;
        const belowStake = XwaysHoarder2.isWinBelowStake();
        this.countupFinishTime = 0;

        const multiplier = 1;
        let winConfigs: WinConfig[] = [];
        for (let i: number = 1; i <= multiplier; i++) {

            const startRatio = XwaysHoarder2.model.winRatio * (i - 1);
            const endRatio = XwaysHoarder2.model.winRatio * i;
            winConfigs = winConfigs.concat(WinConfigUtil.getNormalWinLevels(startRatio, endRatio, i, i == multiplier));
        }


        tl.add(() => controller.setSkipCallback(() => {
            XwaysHoarder2.winView.skipped = true;
            tl.seek("ending", false);
        }),0);
        const firstNormal = winConfigs[0];
        const lastNormal = winConfigs[winConfigs.length - 1];
        const normalWinTl = gsap.timeline();
        const skipCountSound = belowStake;
        let countDuration = lastNormal.duration;


        if (belowStake) {
            countDuration = 0.001;
        }
        if (!XwaysHoarder2.isWinBelowStake()) {
            let cTl:gsap.core.Timeline;
            normalWinTl.add(cTl = XwaysHoarder2.winView.getWinCountUp(
                firstNormal.fromRatio * XwaysHoarder2.model.gameData.playedBetValue,
                firstNormal.toRatio * XwaysHoarder2.model.gameData.playedBetValue,
                countDuration,
                0,
                new PIXI.Point(360, 360),
                firstNormal.textScale,
                firstNormal.toRatio >= 1.5
            ));

            const subDiff: number = (winConfigs[winConfigs.length - 1].name === "LARGE")? -0.15 : 0.1;
            normalWinTl.add(() => {
                XwaysHoarder2Sound.stopSound(XwaysHoarder2Sound.COUNTUP);
                XwaysHoarder2Sound.playTrack(this.getCountupEndSound(winConfigs[winConfigs.length - 1].name));
            }, cTl.duration() + subDiff); //

            const timeDiff = Math.max(tl.duration() - normalWinTl.duration(), 0);
            this.countupFinishTime = (2 * timeDiff) / 3 + 0.5;
            tl.add(normalWinTl, timeDiff);
            tl.add(XwaysHoarder2.winView.setWaysWonText(false), this.countupFinishTime);
        }


        //tl.add(XwaysHoarder2.winView.getCountUpScaleAnimation(0, XwaysHoarder2.model.gameData.totalSpinWinnings, tl.duration(), 0.4, lastLevelConfig.textScale), 0);


        const useTotalWin = XwaysHoarder2.model.gameData.accumulatedRoundWin != XwaysHoarder2.model.gameData.totalSpinWinnings || XwaysHoarder2.model.data.mode != GameMode.NORMAL;
        const stayDuration: number = 0.5;
        XwaysHoarder2.reelView.reels.forEach((reel: Reel, index: number) => {

            reel.model.symbols.forEach((sym: SimpleReelModelSymbolData, symId: number) => {
                tl.add(() => {
                    (<BasicSymbol>sym.positionable).hideNoWinOverlay(0.3)
                }, this.countupFinishTime);
            })
        });
        tl.add(() => {
            // #418
            XwaysHoarder2.keypadPlugin.setWin(XwaysHoarder2.model.gameData.accumulatedRoundWin, useTotalWin, XwaysHoarder2.isWinBelowStake());

            controller.finish();
        }, this.countupFinishTime);

        if (!XwaysHoarder2.isWinBelowStake()) {
            tl.add(XwaysHoarder2.winView.getWinCountUpEnd(XwaysHoarder2.model.gameData.totalSpinWinnings, stayDuration, undefined, undefined,
                (firstNormal.name === "LARGE" || firstNormal.name === "MEDIUM"), firstNormal.name), "<");
            tl.add(() => {
                XwaysHoarder2.winView.getWinCountUpFade(XwaysHoarder2.model.gameData.totalSpinWinnings, stayDuration * 0.5);
            });
        }


        tl.addLabel("ending");
        tl.add(() => {
            controller.setSkipCallback(() => {
                XwaysHoarder2.winView.skipped = true;
            });
        })
    }


    private getCountupEndSound(name: string): string {
        let countUpEndSound: string = "";
        switch (name) {
            case "TINY":
                countUpEndSound = XwaysHoarder2Sound.COUNTUP_END_TINY;
                break;
            case "SMALL":
                countUpEndSound = XwaysHoarder2Sound.COUNTUP_END_SMALL;
                break;
            case "MEDIUM":
                countUpEndSound = XwaysHoarder2Sound.COUNTUP_END_MID;
                break;
            case "LARGE":
                countUpEndSound = XwaysHoarder2Sound.COUNTUP_END_LARGE;
                break;
            default:
                break;
        }

        return countUpEndSound;
    }
}